import { Component, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { DOCUMENT } from '@angular/common';
import { ExportToCsv } from 'export-to-csv';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
})
export class CustomersComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  customerForm: FormGroup;
  arCustomerData = [];
  arCustomerDataSearch = [];
  searchInfo = {};
  userPermissions;
  permissionMap: any = {
    customers_v: false,
    customers_e: false,
  };

  constructor(
    private jobsService: JobsService,
    // Still needed. Inherited inside getAndParseUserPermissions
    private localStorageService: LocalstorageService,
    private renderer2: Renderer2,
    private router: Router,
    private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private _document,
  ) { }

  ngOnInit(): void {
    //Function call to get arcustomer data
    this.getARCustomer();
    this.getARCustomerForDD();
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
    this.loaderService.displayLoader();
    this.disableFormGroupByRole();
    this.customerForm = this.formBuilder.group({
      name: [''],
      customer_id: ['']
    });
    setTimeout(() => {
      this.loadSelect2();
    }, 1000);
  }

  disableFormGroupByRole() {
    setTimeout(() => {
      this.checkForPermission(this.userPermissions['customers'], 'customers');
    }, 1000);
  }

  checkForPermission(permission, val) {
    switch (val) {
      case 'customers':
        this.disableOwnerInfoForm(permission);
        break;
      default:
        break;
    }
  }

  disableOwnerInfoForm(permission) {
    if (permission['view'] == 1 && permission['edit'] == 0) {
      this.permissionMap.customers_v = true;
      this.permissionMap.customers_e = false;
    } else if (permission['view'] == 1 && permission['edit'] == 1) {
      this.permissionMap.customers_v = true;
      this.permissionMap.customers_e = true;
    }
  }

  //To clear datatable
  clearDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('.customers-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To draw datatable with data
  drawDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('.customers-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To get all arcustomer data
  getARCustomer() {
    this.jobsService.getARCustomer(this.searchInfo).subscribe(
      res => this.onARCustomerSuccess(res),
      error => this.onARCustomerError(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerSuccess(result) {
    if (result?.data) {
      this.clearDatatable();
      this.arCustomerData = result.data;
      this.drawDatatable();
    }
    this.loaderService.hideLoader();
  }

  //On error of arcustomer api call
  onARCustomerError(error) {
    this.loaderService.hideLoader();
  }

  getARCustomerForDD() {
    this.jobsService.getARCustomer().subscribe(
      res => this.onARCustomerSuccessSearch(res),
      error => this.onARCustomerErrorSearch(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerSuccessSearch(result) {
    if (result?.data) {
      this.arCustomerDataSearch = result.data;
    }
    this.loaderService.hideLoader();
  }

  //On error of arcustomer api call
  onARCustomerErrorSearch(error) {
    this.loaderService.hideLoader();
  }

  searchInCustomer(value, key) {
    if (value === '') {
      delete this.searchInfo[key];
    }
    this.searchInfo[key] = value;
    this.getARCustomer();
  }

  generateCSV() {
    const options = {
      filename: 'Ar Customer',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      // showTitle: true,
      // title: 'Users Data Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Job', 'Owner', 'Facility/Location', 'Street Address', 'City', 'State', 'Zipcode'] // Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    const arCustomersExport = [];

    this.arCustomerData.forEach(element => {
      const newData = {
        'Customer Name': element.name || '',
        'Customer ID': element.customer_id || '',
        'Contact Name': (element.billing_contacts?.contacts?.[0]?.contactName) || '',
        'Email': (element.billing_contacts?.contacts?.[0]?.contactEmail) || '',
        'Phone Number': (element.billing_contacts?.contacts?.[0]?.phoneNumber) || '',
        'Portal Website/Billing Email': (element.billing_contacts?.contacts?.[0]?.billingEmail) || '',
      };
      arCustomersExport.push(newData);
    });

    csvExporter.generateCsv(arCustomersExport);

    this.closebutton.nativeElement.click();
  }

  //Open owner info page
  openAddEditCustomers(customerId = '') {
    if (this.permissionMap.customers_v && this.permissionMap.customers_e) {
      if (customerId != '') {
        this.router.navigate(['customers/edit_customers', { id: customerId }]);
      }
    }
  }
}
